import useApiRequest from 'api/useApiRequest';
import { fetchSharedDocumentV2 } from 'api/services/shareDocumentService';

const useShareDocument = () => {
  const { request } = useApiRequest();

  const getSharedDocumentV2 = async (params: Parameters<typeof fetchSharedDocumentV2>[1]) => {
    const { data } = await fetchSharedDocumentV2(request, params);
    return data;
  };

  return { getSharedDocumentV2 };
};

export default useShareDocument;
